module.exports = __webpack_public_path__ + "static/media/topic-img2.327a642d.png";